import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPrueba = () => import('./Indexgrilla')
const ViewBastonRFID = () => import('./EjemploBastonRFID')
const ViewBastonBLE = () => import('./EjemploBastonBLE')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'prueba',
        name: 'Prueba',
        component: ViewPrueba,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'baston-rfid',
        name: 'BastonRFID',
        component: ViewBastonRFID,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'baston-ble',
        name: 'BastonBLE',
        component: ViewBastonBLE,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router

